export default __webpack_public_path__ + "static/screeny-85-gpz-s-4-a9e2bb81442053d9fd53dea045a31b39.jpg";